import MobileHeader from '../../components/mobile/MobileHeader';
import MobileRegisterForm from '../../components/mobile/MobileRegisterForm';
import MobileBottomNav, { type NavItem } from '../../components/mobile/MobileBottomNav';

const MobileRegisterPage = () => {
  // Create nav items (no badge needed on register page)
  const navItems: NavItem[] = [
    {
      id: 'home',
      label: '首頁',
      path: '/',
      icon: '🏠',
    },
    {
      id: 'ads',
      label: '廣告',
      path: '/ads',
      icon: '🛒',
    },
    {
      id: 'wish',
      label: '願望',
      path: '/wishes',
      icon: '⭐',
    },
    {
      id: 'profile',
      label: '會員',
      path: '/member',
      icon: '👤',
    },
  ];

  return (
    <div>
      <MobileHeader title="會員註冊" showBack={false} />
      <MobileRegisterForm />
      <MobileBottomNav items={navItems} />
    </div>
  );
};

export default MobileRegisterPage;
